module.exports = __webpack_public_path__ + "img/skypatchLogo.e0d64599.png";